let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dhHcF")).then(() => parcelRequire('5f85G'));